import React from 'react'
import { createRoot } from 'react-dom/client'
import App from 'app/App'
import './index.css'
import 'material-icons/iconfont/material-icons.css'

const container = document.getElementById('app')
const root = createRoot(container)
root.render(<App />)